import { render } from "./profResp.vue?vue&type=template&id=f8eced48&scoped=true"
import script from "./profResp.vue?vue&type=script&lang=js"
export * from "./profResp.vue?vue&type=script&lang=js"

import "./profResp.vue?vue&type=style&index=0&id=f8eced48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8eced48"]])

export default __exports__